








import { defineComponent, ref } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import CreateGroupModal from "@/components/CreateGroupModal";

export default defineComponent({
  name: "AddNewGroup",
  components: { BaseButton, CreateGroupModal },
  setup() {
    const showCreateGroup = ref(false);

    return { showCreateGroup };
  },
});
